export default __webpack_public_path__ + "static/media/Version (5) - Deathly Hallows_09.decd75e9.jpg";